export default "__VITE_ASSET__B$HYWK0J__"